export default function($log, ResolveClass, MsTeamsClass, $window) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;
  vm.consentButton = false;

  vm.refresh = function() {
    vm.consentButton = false;
    $window.location.reload();
  };

  vm.openPopup = function() {
    MsTeamsClass.consentPopupCall()
      .then(() => vm.refresh())
      .catch(() => vm.refresh());
  };

  function activate() {
    $log.debug('Ms Teams Tab Activated');
    ResolveClass.refreshLogin()
      .then(result => {
        if (result === 'logged in') ResolveClass.login();
        else vm.consentButton = true;
      })
      .catch(() => {});
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/msTeamsTab/index.js